export default __webpack_public_path__ + "static/media/devonta-vertical-video.a2fd5816.mp4";